import Card from '../card/card'

class ArticleCard extends Card {}

export default ArticleCard
